module.exports = __webpack_public_path__ + "static/img/search.600b4b57.svg";